module.exports = __webpack_public_path__ + "resources/img/img-vormetric-encryption.78f9b1863b42584fdc35045d370f1429.png";